export default "__VITE_ASSET__BB34r1_1__"